module.exports = __webpack_public_path__ + "img/arrow.bc43279a.svg";